import React, { useState } from "react";
import { AnimatedSection } from "./shared";

const M = `${process.env.REACT_APP_BACKEND_URL}/api/media`;

const teamMembers = [
  { name: "Dr. Neelima", role: "MBBS MD (Gynecology)", tag: "Gynecologist",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_web-dev-starter-7/artifacts/v8xwi7lh_IMG_6089.webp", position: "top" },
  { name: "Dr. Rekha", role: "BAMS Ayurvedic Fertility Specialist", tag: "Ayurveda",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_web-dev-starter-7/artifacts/e8ppb6wq_IMG_6090.jpg", position: "top" },
  { name: "Dr. Jhansi", role: "MBBS MD (Gynecology)", tag: "IVF Specialist",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_web-dev-starter-7/artifacts/3v8wwjfp_WhatsApp%20Image%202026-07-18%20at%2013.48.51.jpg", position: "top" },
  { name: "Dr. Suma Geethika", role: "MBBS DGO (Gynecologist)", tag: "Gynecologist",
    image: `${M}/dr_suma_v3.jpg`, position: "center top" },
  { name: "Dr. Rajeshwari", role: "MBBS MD (Pediatrics)", tag: "Pediatrician",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_web-dev-starter-7/artifacts/uuawyre4_IMG_6086.jpg", position: "top", zoom: "scale-[1.6] origin-top" },
  { name: "Dr. Uma", role: "Diabetologist", tag: "Diabetologist",
    image: "https://customer-assets.emergentagent.com/job_web-dev-starter-7/artifacts/awu8ufi8_WhatsApp%20Image%202026-03-29%20at%2018.52.58.jpeg", position: "top" },
  { name: "Mrs. Revathy R.P", role: "Clinical Nutritionist, 10+ Yrs Experience, Certified in Fertility Nutrition", tag: "Nutritionist",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_web-dev-starter-7/artifacts/ulukme1s_DSC_5473.webp", position: "top" },
  { name: "Mrs. Shadhika", role: "MSc Nutrition, Clinical Nutritionist", tag: "Nutritionist",
    image: `${M}/shadhika.jpg`, position: "center" },
  { name: "Mrs. Shruthi", role: "Childbirth Educator", tag: "Childbirth Educator",
    image: "https://img1.wsimg.com/isteam/ip/52757546-f349-4558-a54e-494d87e21656/WhatsApp%20Image%202024-08-18%20at%2001.17.10.jpeg", position: "top" },
  { name: "Mrs. Minu", role: "Yoga Coach", tag: "Yoga",
    image: `${M}/minu.jpg`, position: "center" },
  { name: "Miss Bhavana", role: "Fitness Coach", tag: "Fitness",
    image: `${M}/bhavana.jpg`, position: "center" }
];

const TeamCard = ({ member, idx }) => (
  <AnimatedSection delay={idx * 0.06}>
    <div
      data-testid={`team-card-${idx}`}
      className="group relative"
    >
      <div className="relative rounded-2xl overflow-hidden bg-emerald_mid shadow-lg shadow-black/20 hover:shadow-xl hover:shadow-accent/10 transition-all duration-500 hover:-translate-y-1">
        {/* Photo */}
        <div className="aspect-[3/4] overflow-hidden">
          {member.image ? (
            <img
              src={member.image}
              alt={member.name}
              className={`w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ${member.zoom || ''}`}
              style={{ objectPosition: member.position }}
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-emerald_mid">
              <span className="font-serif text-5xl text-accent/30">{member.name.charAt(0)}</span>
            </div>
          )}
        </div>

        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-emerald_deep via-emerald_deep/40 to-transparent opacity-80" />

        {/* Tag badge */}
        <div className="absolute top-3 left-3">
          <span className="text-[8px] tracking-[0.15em] uppercase font-bold bg-accent text-emerald_deep px-3 py-1 rounded-full">
            {member.tag}
          </span>
        </div>

        {/* Info at bottom */}
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <h3 className="font-serif text-xl text-bone group-hover:text-accent transition-colors leading-tight">
            {member.name}
          </h3>
          <p className="text-[10px] text-accent tracking-[0.12em] uppercase font-bold mt-1.5 leading-relaxed">
            {member.role}
          </p>
        </div>
      </div>
    </div>
  </AnimatedSection>
);

const TeamSection = () => {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? teamMembers : teamMembers.slice(0, 8);

  return (
    <section id="team" data-testid="team-section" className="py-24 md:py-32 bg-emerald_deep relative overflow-hidden">
      {/* Subtle pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: 'radial-gradient(circle at 30% 70%, #D4AF37 1px, transparent 1px)', backgroundSize: '50px 50px' }} />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <AnimatedSection>
          <div className="text-center mb-16 md:mb-20">
            <span className="text-[10px] tracking-[0.3em] uppercase font-semibold text-accent">Meet The Specialists</span>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight text-bone mt-4">
              The Conception <span className="italic font-light text-accent">Care Team</span>
            </h2>
            <p className="text-bone/50 mt-4 max-w-2xl mx-auto text-base font-serif italic">
              A multidisciplinary team of doctors, nutritionists and wellness professionals — working together for your conception journey.
            </p>
            <div className="gold-divider w-24 mx-auto mt-8" />
          </div>
        </AnimatedSection>

        {/* Cards grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {visible.map((member, idx) => (
            <TeamCard key={member.name} member={member} idx={idx} />
          ))}
        </div>

        {teamMembers.length > 8 && (
          <AnimatedSection>
            <div className="text-center mt-14">
              <button
                onClick={() => setShowAll(!showAll)}
                data-testid="team-show-more-btn"
                className="border border-accent/30 text-accent px-10 py-3.5 text-sm tracking-[0.1em] uppercase font-medium hover:bg-accent hover:text-emerald_deep transition-all duration-300 rounded-full"
              >
                {showAll ? 'Show Less' : `View Entire Team (${teamMembers.length})`}
              </button>
            </div>
          </AnimatedSection>
        )}
      </div>
    </section>
  );
};

export default TeamSection;
